import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { AppProvider } from './contexts/AppContext';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './components/auth/AuthProvider';
import { SettingsProvider } from './contexts/SettingsContext';
import { UserSettingsProvider } from './contexts/UserSettingsContext';

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <AppProvider>
        <UserSettingsProvider>
          <SettingsProvider>
            <App />
          </SettingsProvider>
        </UserSettingsProvider>
      </AppProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
